import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, SmartphoneIcon, RocketIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Página de Ventas',
    description: 'Optimizada para Google Local. Tu negocio visible 24/7.',
    icon: GlobeIcon
  }, {
    title: 'Redes Sociales',
    description: 'Instagram y Facebook que atraen clientes reales.',
    icon: SmartphoneIcon
  }, {
    title: 'Pack Crecimiento',
    description: 'Combo completo para dominar tu zona local.',
    icon: RocketIcon
  }];
  return <section id="servicios" className="py-20 lg:py-24 bg-white" data-id="element-141">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-143">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-144">
            Lo que hacemos por tu negocio
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-145">
            Soluciones diseñadas para negocios locales como el tuyo
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-146">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} whileHover={{
            y: -8
          }} className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer group" data-id="element-147">
                <div className="w-14 h-14 rounded-xl bg-[rgba(255,107,43,0.1)] flex items-center justify-center mb-6 group-hover:bg-accent transition-colors duration-300" data-id="element-148">
                  <Icon className="w-7 h-7 text-accent group-hover:text-white transition-colors duration-300" data-id="element-149" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-dark" data-id="element-150">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-151">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}